import { AxiosError, isAxiosError } from 'axios';

/**
 * Checks if an error is a network-related error that indicates connectivity issues.
 * This includes errors like network failures, DNS resolution failures, and disconnections.
 */
export function isNetworkError(error: unknown): error is AxiosError {
  return (
    isAxiosError(error) &&
    !error.response &&
    // Generic network failure (e.g. offline, DNS failure)
    (error.code === 'ERR_NETWORK' ||
      // DNS could not be resolved
      error.code === 'ERR_NAME_NOT_RESOLVED' ||
      // Explicit browser-reported offline state
      error.code === 'ERR_INTERNET_DISCONNECTED' ||
      // The network interface changed (common when waking a laptop)
      error.code === 'ERR_NETWORK_CHANGED' ||
      // Connection was aborted – frequently what axios reports when a
      // device goes to sleep and the underlying TCP connection is cut.
      error.code === 'ECONNABORTED' ||
      // Axios/browser timeout
      error.code === 'ERR_TIMEOUT')
  );
}
